import React from "react";
import { Modal, ModalBody, ModalHeader, Button } from "reactstrap";

function Suspendmodal({
  modal_animationFlip,
  tog_animationFlip,
  pageid,
  DeleteData,
  message,
}) {
  return (
    <Modal
      id="flipModal"
      isOpen={modal_animationFlip}
      toggle={() => {
        tog_animationFlip();
      }}
      modalClassName="flip"
      centered
      style={{ fonFamily: "IBM Plex Sans,sans-serif" }}
      className="Delete_modal"
    >
      <ModalBody className="modal-body p-5 text-center">
        <lord-icon
          src="https://cdn.lordicon.com/gsqxdxog.json"
          trigger="loop"
          colors="primary:#405189,secondary:#f06548"
          style={{ width: "90px", height: "90px" }}
        ></lord-icon>

        <div className="mt-4 text-center">
          <h4 className="delete_modal_h4">You are about to suspend a {message} ?</h4>
          <p className="text-muted fs-15 mb-4">

          Suspending a {message} will restrict their actions within HomeDotApp

          </p>
        </div>

        <button
          className="btn btn-link link-success fw-medium text-decoration-none"
          onClick={() => {
            tog_animationFlip();
          }}
        >
          {" "}
          <i className="ri-close-line me-1 align-middle"></i>
          Close{" "}
        </button>
        <Button color="danger" className="delete_modal_btn" onClick={(e) => DeleteData(pageid)}>
          {" "}
          Yes, Suspend{" "}
        </Button>
      </ModalBody>
    </Modal>
  );
}

export default Suspendmodal;
